const LISTAR_DADOS = (state, payload) => {
  state.items = payload
}

const BUSCANDO = (state, payload) => {
  state.buscando = payload
}

const INSERIR_PERFIL = (state,  payload) => {
  state.items.push(payload)
}

const ATUALIZAR_PERFIL = (state, payload) => {
  state.items = state.items.map(item => {
    if(item.id === payload.id) {
      return payload;
    }
    return item;
  })
}



export {
  LISTAR_DADOS,
  BUSCANDO,
  INSERIR_PERFIL,
  ATUALIZAR_PERFIL
}